import $http from '@/libs/axios'

class ReservationsAPI {
  public static async addReservation(body: any) {
    return (await $http.put('/queues/reserve-quest', body)).data
  }

  public static async editReservation(body: any) {
    return (await $http.post('queues/reservation/update', body)).data
  }

  public static async getSettings(branchId: any) {
    return (await $http.get(`queues/reservation/settings/${branchId}`)).data
  }

  public static async updateStatus(body: any) {
    return (await $http.put('queues/reservation/update-status', body)).data
  }
}

export default ReservationsAPI
